import noop from "lodash/noop";

import {
  AnalyticsComponent,
  AnalyticsFieldName,
  OnboardingV2AnalyticsEvent,
  OnboardingV2AnalyticsPageView,
} from "@/constants/analytics/Analytics";
import { MedicalReviewState } from "@/constants/Onboarding";
import { useAnalytics } from "@/services/Analytics";
import { useOnboardingDispatch } from "@/store/reducers/onboarding";

interface ReviewActionConfig {
  analyticsEvent: OnboardingV2AnalyticsEvent;
  handler: () => void;
}

interface UseOnboardingMedicalReviewHandler {
  onMedicalReviewActionPress: (state: MedicalReviewState) => void;
}

const useOnboardingMedicalReviewHandler =
  (): UseOnboardingMedicalReviewHandler => {
    const { track } = useAnalytics();
    const { setMedicalReviewCleared } = useOnboardingDispatch();

    // TODO: wire Pending and NotApproved handlers when navigation targets exist
    const ReviewActionConfigRecord: Record<
      MedicalReviewState,
      ReviewActionConfig
    > = {
      [MedicalReviewState.Approved]: {
        analyticsEvent: OnboardingV2AnalyticsEvent.MedicalReviewGotItPressed,
        handler: setMedicalReviewCleared,
      },
      [MedicalReviewState.NotApproved]: {
        analyticsEvent:
          OnboardingV2AnalyticsEvent.MedicalReviewLearnMorePressed,
        handler: noop,
      },
      [MedicalReviewState.Pending]: {
        analyticsEvent: OnboardingV2AnalyticsEvent.MedicalReviewExplorePressed,
        handler: noop,
      },
    };

    const onMedicalReviewActionPress = (state: MedicalReviewState) => {
      const config = ReviewActionConfigRecord[state];

      track(config.analyticsEvent, {
        [AnalyticsFieldName.Component]: AnalyticsComponent.Button,
        [AnalyticsFieldName.Source]: OnboardingV2AnalyticsPageView.Modal,
      });

      config.handler();
    };

    return { onMedicalReviewActionPress };
  };

export default useOnboardingMedicalReviewHandler;
